/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// @ts-check
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

const promotionDialog = document.querySelector('.popup-wrap')
const promotionDialogSeconds = document.querySelector('.seconds')
const promotionDialogClose = document.querySelector('.popup .btn-close')
const promotionDialogStorageKey = 'PromotionDialogLastShownAt'

/** @type number intervalId */ let promotionModalTimer

document.addEventListener("DOMContentLoaded", function(event) {
  openPromotionDialog()
});

function openPromotionDialog() {
  const storage = localStorage.getItem(promotionDialogStorageKey)
  const lastDateShown = !storage ? undefined : new Date(storage)
  if (lastDateShown) {
    const days = 2
    const until = new Date(lastDateShown.getTime() + days * 60 * 60 * 1000)
    if (new Date().getTime() <= until.getTime()) {
      return
    }
  }

  let duration = 20;
  promotionDialog.style.display = 'unset';
  promotionModalTimer = setInterval(function () {
    duration--;
    if (duration == 0){
      closeModalAndStopTimer()
    }
  }, 1000)

  promotionDialogClose.addEventListener("click", function () {
    closeModalAndStopTimer()
    localStorage.setItem(promotionDialogStorageKey, new Date().toJSON())
  });
}

function closeModalAndStopTimer() {
  clearInterval(promotionModalTimer);
  promotionDialog.style.display = 'none';
}